module.exports = __webpack_public_path__ + "index_pc/img/a1.6c8356c0.png";